import React from 'react';

import './MainPage.css';

class MainPage extends React.Component {
    render() {
        return (
            <div className="row">
                <div className="column2">                
                </div>
            </div>
        )
    }
}

export default MainPage;
